<template>
  <div>
    <back-btn/>
    <v-row justify="center">
      <v-col cols="12" md="6">
        <township-form @emitTownshipData="createTownship" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import TownshipForm from "@/components/township/TownshipForm";
import BackBtn from '@/components/navigation/BackBtn.vue';

export default {
  components: {
    TownshipForm,
    BackBtn,
  },
  data: () => ({}),
  methods: {
    createTownship(payload) {
      console.log(payload);
      this.$store.dispatch("Township/createTownship", payload).then(() => {
        this.$router.push("/township");
      });
    },
  },
};
</script>
